import Pill from '@/components/Pill'
import { THREAD_SEARCH_FILTERS } from './threadSearchFilters'
import { ThreadSearchFilterIcon } from './threadSearchFilterIcons'
import styles from './ThreadsSectionAllThreadsDialog.module.scss'

export default function ThreadsSearchDialogFilters({ filter, onChange }) {
  return (
    <div className={styles.filterRow} role="group" aria-label="Filter threads">
      {THREAD_SEARCH_FILTERS.map((pill) => (
        <Pill
          key={pill.id}
          label={pill.label}
          icon={pill.id === 'all' ? null : <ThreadSearchFilterIcon id={pill.id} />}
          shape="pill"
          surface="secondary"
          active={filter === pill.id}
          aria-pressed={filter === pill.id}
          onClick={() => onChange(pill.id)}
        />
      ))}
    </div>
  )
}
